<template>
  <div class="editorial">
    <div class="editorial_nav">
      <div class="editorial_txt">
        <div class="iconfont iconhomeicon evolution_tu" style="margin-right: 5px;"></div>
        <div class="editorial_txt2" style="cursor: pointer;" @click="tiao">
          首页 <span class="span1">></span><span style="color: var(--xt);">公益海报</span>
        </div>
      </div>
      <div class="editorial_left">
        <div class="kuaiwai">
          <div v-for="(item,index) in list3" class="kuai" @click="jump2(item)">
            <img :src="item.titlePhoto" alt="" v-if="item.titlePhoto">
            <img v-if="!item.titlePhoto" src="http://uniappfile.boyuancb.com/UploadFile/SiteContent/TitlePhoto/988227300d6339151f66801e0815539.png" alt="">
            <div class="kuai_zi">{{item.title}}</div>
          </div>
        </div>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="curr"
          layout="prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
      <div class="editorial_right">
        <advertisement :num="num" :list2="list2"></advertisement>
      </div>
    </div>
  </div>
</template>

<script>
//配置右侧广告栏
import advertisement from "../public/evolution/advertisement.vue"

export default {
  components:{
    advertisement
  },
  data () {
    return {
      tu: false,
      curr: 1,//当前页数
      limit: 10,
      total: 0,//总条数
      list3: [],//列表数据
      num:{
        wai: false,
        zixun: true,
        xia: true,
        look: false,
        video2: true,
      },//控制广告栏的显示隐藏
      list2: [
        {
          id: 1,
          txt: '多西他赛对进展期胃癌术后化疗疗效影响向...'
        },
        {
          id: 2,
          txt: '中国腹腔镜减重代谢外科20年研究文献分析...'
        }
      ],//外科天地
      list: [
        {
          id: 1,
          txt: '创新为魂 匠心筑梦',
          time: '2020-03-25',
          name: '董家鸿',
          txt2: '清华长庚医院院长，《中华消化外科杂志》总编辑，中国工程院院士，美国外科协会荣誉院士，欧洲外科协会荣誉院士，法国国家外科科学院外籍荣誉院士，美国外科学院院士国际消化外科学会执行委员会委员',
          num: '1096'
        },
        {
          id: 2,
          txt: '创新为魂 匠心筑梦',
          time: '2020-03-25',
          name: '董家鸿',
          txt2: '清华长庚医院院长，《中华消化外科杂志》总编辑，中国工程院院士，美国外科协会荣誉院士，欧洲外科协会荣誉院士，法国国家外科科学院外籍荣誉院士，美国外科学院院士国际消化外科学会执行委员会委员',
          num: '1096'
        },
        {
          id: 3,
          txt: '创新为魂 匠心筑梦',
          time: '2020-03-25',
          name: '董家鸿',
          txt2: '清华长庚医院院长，《中华消化外科杂志》总编辑，中国工程院院士，美国外科协会荣誉院士，欧洲外科协会荣誉院士，法国国家外科科学院外籍荣誉院士，美国外科学院院士国际消化外科学会执行委员会委员',
          num: '1096'
        },
        {
          id: 4,
          txt: '创新为魂 匠心筑梦',
          time: '2020-03-25',
          name: '董家鸿',
          txt2: '清华长庚医院院长，《中华消化外科杂志》总编辑，中国工程院院士，美国外科协会荣誉院士，欧洲外科协会荣誉院士，法国国家外科科学院外籍荣誉院士，美国外科学院院士国际消化外科学会执行委员会委员',
          num: '1096'
        },
        {
          id: 5,
          txt: '创新为魂 匠心筑梦',
          time: '2020-03-25',
          name: '董家鸿',
          txt2: '清华长庚医院院长，《中华消化外科杂志》总编辑，中国工程院院士，美国外科协会荣誉院士，欧洲外科协会荣誉院士，法国国家外科科学院外籍荣誉院士，美国外科学院院士国际消化外科学会执行委员会委员',
          num: '1096'
        },
        {
          id: 6,
          txt: '创新为魂 匠心筑梦',
          time: '2020-03-25',
          name: '董家鸿',
          txt2: '清华长庚医院院长，《中华消化外科杂志》总编辑，中国工程院院士，美国外科协会荣誉院士，欧洲外科协会荣誉院士，法国国家外科科学院外籍荣誉院士，美国外科学院院士国际消化外科学会执行委员会委员',
          num: '1096'
        },
        {
          id: 7,
          txt: '创新为魂 匠心筑梦',
          time: '2020-03-25',
          name: '董家鸿',
          txt2: '清华长庚医院院长，《中华消化外科杂志》总编辑，中国工程院院士，美国外科协会荣誉院士，欧洲外科协会荣誉院士，法国国家外科科学院外籍荣誉院士，美国外科学院院士国际消化外科学会执行委员会委员',
          num: '1096'
        },
        {
          id: 8,
          txt: '创新为魂 匠心筑梦',
          time: '2020-03-25',
          name: '董家鸿',
          txt2: '清华长庚医院院长，《中华消化外科杂志》总编辑，中国工程院院士，美国外科协会荣誉院士，欧洲外科协会荣誉院士，法国国家外科科学院外籍荣誉院士，美国外科学院院士国际消化外科学会执行委员会委员',
          num: '1096'
        },
        {
          id: 9,
          txt: '创新为魂 匠心筑梦',
          time: '2020-03-25',
          name: '董家鸿',
          txt2: '清华长庚医院院长，《中华消化外科杂志》总编辑，中国工程院院士，美国外科协会荣誉院士，欧洲外科协会荣誉院士，法国国家外科科学院外籍荣誉院士，美国外科学院院士国际消化外科学会执行委员会委员',
          num: '1096'
        }
      ],//专家列表
    }
  },

  methods:{
      //公益广告
      GetHomePageBlockInfo(){
        var that = this;
        that.$httphelper.GetHomePageBlockInfo({
          "journalId": that.$_JournalId,
          "pChannelId": 0,
          "channelId": 2803,
          "jChannelID": 0,
          "dataSourceType": 1,
          "dataShowType": 1,
          "curr": that.curr,
          "limit": that.limit,
        }).then(res => {
          if(res.code==200){
            that.list3 = res.data || '';
            that.total = res.totalcount;
            that.$loading.hideLoading();
          }else{
            that.$alert(res.msg, '提示', {
              confirmButtonText: '确定',
              callback: action => {

              }
            });
          }
        });
      },
      tiao(){
        this.$router.push({path:'/home'});
      },
      jump2(item){
        var data = JSON.stringify(item);
        this.$router.push({path:'/poster_details',query:{item:data}});
      },
      index(){
        sessionStorage.setItem('routerIndex',0);
        this.total = this.list.length;
        this.GetHomePageBlockInfo();
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
      },
      handleCurrentChange(val) {
        this.curr = val;
        this.GetHomePageBlockInfo();
        console.log(`当前页: ${val}`);
      },
  },
  created(){
    // this.$loading.showLoading();
    this.index();
  }
}
</script>

<style lang="scss" scoped>
*{
    margin: 0;
    padding: 0;
}
.editorial{
  width: 100%;
  min-width: 1366px;
  background-color: #FFFFFF;
  .editorial_nav{
    width: 85%;
    margin: 0 auto;
    overflow: hidden;
    padding-bottom: 42px;
    .editorial_txt{
      width: 100%;
      margin-top: 24px;
      margin-bottom: 26px;
      overflow: hidden;
      .evolution_tu{
        width: 19px;
        height: 17px;
        float: left;
      }
      .editorial_txt2{
        float: left;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #010101;
        .span1 {
          margin: 0 5px;
        }
        .span2 {
          color: var(--xt);
        }
      }
    }
    .editorial_left{
      width: 72%;
      margin-right: 3%;
      float: left;
      .kuaiwai{
        width: 100%;
        margin: 0 auto;
        overflow: hidden;
        .kuai{
          width: 18%;
          margin-right: 2.5%;
          float: left;
          text-align: center;
          margin-bottom: 20px;
          cursor: pointer;
          img{
            width: 100%;
            height: 280px;
          }
        }
        .kuai:nth-child(5n){
          margin-right: 0;
        }
        .kuai_zi{
          width: 100%;
          line-height: 50px;
          white-space: nowrap;//强制字体不换行
          text-overflow: ellipsis;//超出字体隐藏
          overflow:hidden;
        }
      }
      .el-pagination{
        text-align: center;
        margin-top: 30px;
      }
    }
    .editorial_right{
      width: 25%;
      float: left;
    }
  }
}
.add1 {
  color: var(--xt) !important;
  text-decoration: underline;
}

.add2 {
  color: var(--xt) !important;
}

.add3 {
  background-color: #FAFAFA !important;
}
</style>



// WEBPACK FOOTER //
// src/components/nav/poster.vue